(function () {
  if (window.__everloveGuardDrawerFinal) return;
  window.__everloveGuardDrawerFinal = true;

  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  function isVisible(el) {
    return !!(el && el.offsetParent !== null);
  }

  function getWrap() {
    // Use the visible customizer (product page), not hidden quick-add
    const wraps = qsa('[data-everlove-customize]');
    return wraps.find(isVisible) || wraps[0] || null;
  }

  function getForm(wrap) {
    if (!wrap) return null;
    return wrap.closest('form[action*="/cart/add"]') || null;
  }

  function getConfig(wrap) {
    return {
      needsUpload: wrap.getAttribute('data-needs-upload') === 'true',
      needsName: wrap.getAttribute('data-needs-name') === 'true',
    };
  }

  function getFields(wrap) {
    return {
      image: qs('#everlove-image', wrap) || qs('input[name="properties[Custom Image]"]', wrap),
      name: qs('#everlove-name', wrap) || qs('textarea[name="properties[Name]"]', wrap),
      consent: qs('#everlove-consent', wrap) || qs('input[name="properties[Production Consent]"]', wrap),
      error: qs('#everlove-error', wrap) || qs('.everlove-error', wrap),
    };
  }

  function findAddButton(form) {
    if (!form) return null;
    return (
      form.querySelector('button[name="add"]') ||
      form.querySelector('button[type="submit"]') ||
      form.querySelector('input[name="add"]') ||
      form.querySelector('input[type="submit"]') ||
      null
    );
  }

  function showError(wrap, msg) {
    const f = getFields(wrap);
    if (f.error) {
      f.error.textContent = msg;
      f.error.style.display = 'block';
    }
  }

  function clearError(wrap) {
    const f = getFields(wrap);
    if (f.error) f.error.style.display = 'none';
  }

  function validate(wrap) {
    if (!wrap) return true;

    const c = getConfig(wrap);
    const f = getFields(wrap);
    const missing = [];

    if (c.needsUpload) {
      const ok = !!(f.image && f.image.files && f.image.files.length > 0);
      if (!ok) missing.push('upload an image');
    }

    if (c.needsName) {
      const ok = !!(f.name && f.name.value && f.name.value.trim().length > 0);
      if (!ok) missing.push('enter the name');
    }

    // ALWAYS required if customizer exists
    const consentOk = !!(f.consent && f.consent.checked);
    if (!consentOk) missing.push('check the box');

    if (missing.length) {
      showError(wrap, 'Please ' + missing.join(', ') + ' before adding to cart.');
      return false;
    }

    clearError(wrap);
    return true;
  }

  function setButtonState(btn, ok) {
    if (!btn) return;
    btn.disabled = !ok;
    btn.setAttribute('aria-disabled', (!ok).toString());
    if (!ok) btn.classList.add('everlove-disabled-atc');
    else btn.classList.remove('everlove-disabled-atc');
  }

  function isAddToCartRequest(url, method) {
    const u = String(url || '');
    const m = String(method || 'GET').toUpperCase();
    return m === 'POST' && (u.includes('/cart/add') || u.includes('/cart/add.js'));
  }

  // ---- Init on product page ----
  function init() {
    const wrap = getWrap();
    if (!wrap) return;

    const form = getForm(wrap);
    if (!form) return;

    const btn = findAddButton(form);

    // Initial state
    setButtonState(btn, validate(wrap));

    // Update as they interact
    const update = () => setButtonState(btn, validate(wrap));
    wrap.addEventListener('input', update, true);
    wrap.addEventListener('change', update, true);

    // Block clicks (some cart drawers bypass submit)
    if (btn) {
      btn.addEventListener('click', function (e) {
        const ok = validate(wrap);
        setButtonState(btn, ok);
        if (!ok) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
          wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true);
    }

    // Block normal submit (backup)
    form.addEventListener('submit', function (e) {
      const ok = validate(wrap);
      setButtonState(btn, ok);
      if (!ok) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  }

  // ---- Block AJAX add-to-cart (fetch + XHR) for cart drawer ----
  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      const req = input && typeof input === 'object' && 'url' in input ? input : null;
      const url = typeof input === 'string' ? input : (req ? req.url : '');
      const method = (init?.method || req?.method || 'GET').toUpperCase();

      if (isAddToCartRequest(url, method)) {
        const wrap = getWrap();
        // Only enforce if customizer exists on the visible product page
        if (wrap && !validate(wrap)) {
          return Promise.reject(new Error('Everlove blocked add to cart (missing required fields).'));
        }
      }
    } catch (_) {}
    return originalFetch.apply(this, arguments);
  };

  const open = XMLHttpRequest.prototype.open;
  const send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ev_method = method;
    this.__ev_url = url;
    return open.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    try {
      const method = (this.__ev_method || 'GET').toUpperCase();
      const url = String(this.__ev_url || '');

      if (isAddToCartRequest(url, method)) {
        const wrap = getWrap();
        if (wrap && !validate(wrap)) {
          this.abort();
          return;
        }
      }
    } catch (_) {}
    return send.apply(this, arguments);
  };

  // Clear error as soon as they interact
  document.addEventListener('input', function (e) {
    const wrap = getWrap();
    if (wrap && wrap.contains(e.target)) clearError(wrap);
  }, true);

  document.addEventListener('change', function (e) {
    const wrap = getWrap();
    if (wrap && wrap.contains(e.target)) clearError(wrap);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
